import Sitewide from './sitewide'

export default (ctx, inject) => {
    const { nuxtState, $axios, $config, app } = ctx
    const sitewide = new Sitewide(ctx, nuxtState.sitewideData)

    window.onNuxtReady(async () => {
        // skip this if we are in preview mode.
        // We do not want to override the preview data set by getPreviewStory() server side
        if (sitewide.isNavbarPreview) return

        // try catch this and Log the error as it should never fail
        try {
            const { data } = await $axios.get(`${$config.platform.apis.sitewide}navbar`)
            if (!data) {
                if (app.$log) app.$log.error('CRITICAL ERROR: Navbar is empty response!', data)
                return
            }
            sitewide.setNavbarStory(data)
        } catch (error) {
            // Using app.$log because $log won't exist in context when this plugin runs but will when we reach this exection.

            const err = {
                error,
            }
            if (error.response?.status) err.status = error.response.status
            if (error.response?.statusText) err.statusText = error.response.statusText
            if (error.message) err.message = error.message

            if (app.$log) app.$log.error('CRITICAL ERROR: Cannot get navbar!', err)
            else console.error('SitewideData: App.$Log not available')
        }
    })

    inject('sitewideData', sitewide)
}
